import {
  validateAddressBuilding,
  validateShippingAddressCity,
  validateShippingAddressPrefectureCode,
  validateShippingAddressStreet,
  validateFamilyName,
  validateFamilyNameKana,
  validateFirstName,
  validateFirstNameKana,
  validatePhone,
  validatePostCode,
} from './MembersValidation'
import {ValidationSignupInput} from './ValidateMembersSignupInput'
import {ValidationAddressInput} from './ValidateMembersAddressInput'

export type ValidationShippingAddressInput =
  Pick<ValidationSignupInput,
    'familyName' | 'firstName'
    | 'familyNameKana' | 'firstNameKana'> &
  Pick<ValidationAddressInput,
    'postCode'
    | 'addressPrefectureCode' | 'addressCity' | 'addressStreet' | 'addressBuilding'> & {
  phone: string
}

export type ValidateShippingAddressResultDetail = {
  [K in keyof ValidationShippingAddressInput]: string[]
}

export type ValidationShippingAddressResult = {
  hasError: boolean
  errors: ValidateShippingAddressResultDetail
}

export const validateShippingAddressInput = (
  input: ValidationShippingAddressInput,
): ValidationShippingAddressResult => {
  const details: ValidateShippingAddressResultDetail = {
    familyName: validateFamilyName(input.familyName),
    firstName: validateFirstName(input.firstName),
    familyNameKana: validateFamilyNameKana(input.familyNameKana),
    firstNameKana: validateFirstNameKana(input.firstNameKana),
    postCode: validatePostCode(input.postCode),
    addressPrefectureCode: validateShippingAddressPrefectureCode(input.addressPrefectureCode),
    addressCity: validateShippingAddressCity(input.addressCity),
    addressStreet: validateShippingAddressStreet(input.addressStreet),
    addressBuilding: validateAddressBuilding(input.addressBuilding),
    phone: validatePhone(input.phone),
  }

  const hasError = Object.values(details)
    .map(errorArray => errorArray.length)
    .some(length => length > 0)

  return {
    hasError: hasError,
    errors: details,
  }
}
